import React,{ Component } from 'react';
import $ from 'jquery';
import {Link } from 'react-router';
import * as actions from './../../actions';
import {connect} from 'react-redux';

class Footer extends Component{
	constructor(props){
		super(props);
		this.state={
			foo_brands: [],
			tot_data:[],
			email:'',
		    mobiles:'',
		    timings:'',
		}
		this.getCategories=this.getCategories.bind(this);
		this.getCustomerCareDetails=this.getCustomerCareDetails.bind(this);
	}
	getCustomerCareDetails()
	{
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from: 'desktop_web',};
		var data2=JSON.stringify(data1);
		$.ajax({
		    method: 'POST',
		    url: baseUrl+'getCustomerSupportDetails',
		    dataType:'json',
		    data: {req:data2},
		    success: function(data)
		    {
		        this.setState({
		            email:data.email,
		            timings: data.timings,
		            mobiles: data.phone,
		        });
		    }.bind(this),
		    error: function(err)
		    {
		        
		  	}
		});
	}
	getCategories()
	{
		var baseUrl='https://aquadeals.in/admin/web3/user/';
        var data1={from: 'desktop_web'};
        var data2=JSON.stringify(data1);
        $.ajax({
            method: 'POST',
            url: baseUrl+'Getcategories',
            dataType:'json',
            data: {req:data2},
            success: function(data)
            {
              // console.log(data)
              this.setState({
                  tot_data:data.deal_categories,
              });
            }.bind(this),
            error: function(err)
            {
                // console.log("Error"+err);
            }
        });
	}
	componentDidMount()
	{
		// console.log(this.props.formdata);
		// this.props.test();
		this.getCategories();
		this.getCustomerCareDetails();
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from: 'desktop_web',};
		var data2=JSON.stringify(data1);
		$.ajax({
  	    	method: 'POST',
    		url: baseUrl+'GetBrands',
      		dataType:'json',
      		data: {req:data2},
      		success: function(data)
      		{
        		this.setState({
	       			foo_brands:data.brands,
	       		});
  			}.bind(this),
  			error: function(err)
  			{
  				// console.log("Error"+err);
  			}
        })
	}
	render(){
		var foo_brands=this.state.foo_brands.map(function(brand,index){
			return(
				<li key={brand.tid} onClick={()=>{location.reload(); $(window).scrollTop(0);}}><Link to={"/web/pdeals/"+brand.url_dtype_name+"/"+brand.url_name+"/"+brand.tid+"/"+brand.type+"/"+brand.page}>{brand.name}</Link></li>
			);
		})
		var categories = this.state.tot_data.map((category, index) => (<Category key={index} data={category} />));
		
		return(
		<div style={{clear:'both'}}>
			<section className="dwnld_blk">
				<h2>Download AquaDeals App</h2>
				<p>Download our Android app today to have a complete access of Aqua products</p>
				<a href="https://play.google.com/store/apps/details?id=com.aquadeals.user&hl=en" target="_blank" title=""><img src={'https://aquadeals.in/admin/assets/images/web_imgs/google_play_store_icon.png'} alt="Download" /></a>
			</section>
		{/*  download block end */}
		{/*  site map start */}
		<section className="site_map">
			<div className="container">
				<div className="row ctgors_site_map">
					<div className="col-md-9">
						{categories}
					</div>
					<div className="col-md-3">
						<h4>Contact Customer Care</h4>
						<div className="home_care_blk">
							<div className="home_care_img">
								<img src={"https://aquadeals.in/admin/assets/icons/web_icons/cc_head_icon.png"} alt=" " />
							</div>
							<ul>
	                            {this.state.email ? <li><i><img src={'https://aquadeals.in/admin/assets/icons/web_icons/email_icon_md.png'} alt="Email" /></i><a>{this.state.email}</a></li> : ''}
	                            {this.state.mobiles ? <li><i><img src={'https://aquadeals.in/admin/assets/icons/web_icons/call_icon_md.png'} alt="Call" /></i><a>{this.state.mobiles}</a></li> : ''}
	                            {this.state.timings ? <li><i><img src={'https://aquadeals.in/admin/assets/icons/web_icons/timing_md.png'} alt="Timings" /></i><a>{this.state.timings}</a></li> : ''}
                          	</ul>
						</div>
					</div>
				</div>
				<div className="row brand_site_map">
					<h3>Brands</h3>
					<ul>
						{foo_brands}
						<li><a href="http://blog.aqua.deals" target="_blank" >AquaDeals Blog</a></li>
					</ul>
				</div>
			</div>
		</section>
		</div>
		)
	}
}


 class Category extends Component{
  constructor(){
    super();
    this.state={
      
    };
    
  }
  render(){
    var cat_list=this.props.data;
    return(
        <div className={"col-md-3 col-sm-3 col-xs-6"}>
			<h3>{cat_list.dtype}</h3>
			{cat_list.categories.map(function(cat){
				return(
					<ul>
						<li onClick={()=>{location.reload(); $(window).scrollTop(0);}}><Link to={(cat.dtype==='1' || cat.dtype==='8') ? '/web/'+cat.url_dtype_name+'/'+cat.url_name+'/'+cat.id : '/web/'+cat.url+'/'+cat.url_dtype_name+'/'+cat.url_name+'/'+cat.id+'/'+cat.category+'/'+cat.dtype }>{cat.title}</Link></li>
					</ul>
					);
			})}
		</div>
    );
  }
}
function mapStateToProps(state){
  return {
    errorMessage:state.auth.error,
    authenticated:state.auth.authenticated,
    leads:state.auth.leads
  };
}

export default connect(mapStateToProps,actions)(Footer);



/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Common/Footer.js
 **/